import {
  REFRESH_PHOTOS,
	SET_PHOTOS,
  ADD_PHOTO,
  UPDATE_PHOTO,
  GET_PHOTO,
	FINISH_GET_PHOTO,
  DELETE_PHOTO
} from './types';

export const refreshPhotos = () => {
	return {
    type: REFRESH_PHOTOS,
    payload: null,
  };
}
export const setPhotos = (params) => {
	return {
    type: SET_PHOTOS,
    payload: params,
  };
}

export const addPhoto = (params) => {
	return {
    type: ADD_PHOTO,
    payload: params,
  };
}

export const updatePhoto = (params) => {
	return {
    type: UPDATE_PHOTO,
    payload: params,
  };
}

export const getPhoto = () => {
  return {
    type: GET_PHOTO,
    payload: [],
  };
};

export const finishGetPhoto = (params) => {
  return {
    type: FINISH_GET_PHOTO,
    payload: params,
  };
};

export const deletePhoto = (params) =>{
  return {
    type: DELETE_PHOTO,
    payload: params
  }
}